export default __webpack_public_path__ + "static/media/nsdl_icon.47af40e2.png";